/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
@format
@flow
*/

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  useDispatch, useSelector, shallowEqual,
} from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { InView } from 'react-intersection-observer';
import { eventNames } from '@ziynx/analytics';
import {
  withAppManager, useNotification, LoadingSpinner, formatDate,
} from '@ziynx/components/utilities';
import { Heading, Body } from '@ziynx/components/typography';
// import { Button, ButtonPillGroup } from '@ziynx/components/buttons';
import Headline from '@ziynx/components/headlines';
import Icon from '@ziynx/components/icons';
import Link from '@ziynx/components/links';
import Card from '@ziynx/components/cards';
import { ContentContainer, PageTemplate } from '@ziynx/components/layout';
import Colors from '@ziynx/theme/colors';
import type { ManagedProps } from '@ziynx/flow-types/appManager';
import type { Viewports } from '@ziynx/flow-types/globals';
import ActionTypes from '@ziynx/action-types';
import DestructiveModal from '../Modals/DestructiveModal';

type Props = $ReadOnly<{|
  viewport: Viewports,
  /**
   * Navigation stack
   */
  history: Object,
|}>;

type DispatchAction = {
  type: string,
} => void;

type Location = {
  state: {
    from: string,
  }
};

const QuestionsWrapper = styled.div`
  ${({ isDesktop }) => isDesktop && 'margin-top: 40px;'}
`;

const StyledHeadline = styled(Headline)`
  margin-bottom: 40px;
`;

// const StyledButtonPillWrapper = styled.div`
//   display: flex;
//   padding-top: 24px;
//   padding-bottom: 40px;
//   position: relative;
//   ${({ isMobile }) => (isMobile
//     ? 'overflow-x: scroll; overflow-y: hidden; white-space: nowrap;}'
//     : 'flex-wrap: wrap;')
// }
//   &::-webkit-scrollbar { width: 0; background: transparent; display: none;}
//   ${({ isMobile, viewport }) => isMobile && (viewport === 'mobileSmall' ? 'margin-left: -16px; margin-right -16px;' : 'margin-left: -3.8%; margin-right: -3.8%;')}
// `;

// const PillWrapper = styled.div`
//   margin-right: 16px;
//   overflow: visible;
//   ${({ isMobile, firstChild, viewport }) => isMobile && firstChild && `margin-left: ${viewport === 'mobileSmall' ? '16px' : '3.8%'};`}
//   ${({ isMobile, lastChild, viewport }) => isMobile && lastChild && `margin-right: 0; padding-right: ${viewport === 'mobileSmall' ? '16px' : '3.8%'};`}
// `;

const StyledCard = styled(Card)`
  margin-bottom: 24px;
`;

const EmptyWrapper = styled.div`
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 16px;
`;

const TextWrapper = styled.div`
  margin-bottom: 4px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
`;

const JobsScreen = (props: ManagedProps<Props>): React$Node => {
  const { viewport, history } = props;
  const dispatch: DispatchAction = useDispatch();
  const location: Location = useLocation();
  const { notificationDispatch } = useNotification();
  const isMobileSmall = viewport === 'mobileSmall';
  // const isMobile = viewport === 'mobileSmall' || viewport === 'mobile';
  const jobService = useSelector(({ job }) => job || {}, shallowEqual);
  // FOR ARCHIVE FEATURE
  const [jobId, setJobId] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalFunction, setModalFunction] = useState('archive');

  // FOR FILTER FUNCTIONALITY
  // const [filteredContent, setFilteredContent] = useState();
  // const [activeFilter, setActiveFilter] = useState('jobPosts');
  // const [filterQty, setFilterQty] = useState({
  //   jobPosts: jobService?.results,
  //   archived: jobService?.results?.filter((item) => item?.archived),
  // });

  const resetNotification = (type: string) => {
    setTimeout(() => {
      switch (type) {
      case 'removal':
        dispatch({
          type: ActionTypes.job.clearRemoval,
        });
        break;
      case 'jobItem':
      default:
        dispatch({
          type: ActionTypes.jobItem.clear,
        });
      }
    }, 5000);
  };

  useEffect(() => {
    dispatch({
      type: ActionTypes.job.getAllJobs.START,
      id: 'me',
      page: 0,
    });
  }, []);

  // useEffect(() => {
  //   // dispatch({
  //   //   type: ActionTypes.statementItem.clear,
  //   // });
  //   const jobPosts = jobService?.results;
  //   const archived = jobService?.results?.filter((item) => item?.archived === true);
  //   setFilterQty({
  //     jobPosts: jobService?.results?.length,
  //     archived: archived?.length,
  //   });
  //   if (activeFilter === 'jobPosts') {
  //     setFilteredContent(jobPosts || []);
  //   }
  //   if (activeFilter === 'archived') {
  //     setFilteredContent(archived || []);
  //   }
  // }, [jobService?.results, activeFilter]);

  useEffect(() => {
    if (history?.location?.state?.from === 'company profile') {
      dispatch({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.navigated_all_jobs,
        properties: {
          referrer: history.location.state?.from,
        },
      });
    } else {
      dispatch({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.navigated_all_jobs,
      });
    }
  }, [history?.location?.state?.from]);

  // FOR ARCHIVE FEATURE
  useEffect(() => {
    if (jobService?.archiveSuccess && !jobService?.archiveFetch) {
      dispatch({
        type: ActionTypes.jobItem.clear,
      });
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: `Job post has been ${modalFunction}d successfully.`,
        },
      });
    }
    if (jobService?.archiveError && !jobService?.archiveFetch) {
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'error',
          content: 'Something went wrong. Please try again.',
        },
      });
    }
  }, [jobId, jobService?.archiveSuccess, jobService?.archiveError]);

  useEffect(() => {
    if (location?.state?.from === '/jobs/create-post') {
      const notice = jobService?.patchSuccess ? 'edited' : 'created';
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: `Job post was successfully ${notice}.`,
        },
      });
      dispatch({ type: ActionTypes.job.clearPatchedJob });
      history.replace();
    }
  }, [location?.state?.from]);

  useEffect(() => {
    if (jobService?.removalSuccess && !jobService?.removing) {
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: 'Job post has been removed successfully.',
        },
      });
      resetNotification('removal');
    }
    if (jobService?.removalError && !jobService?.removing) {
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'error',
          content: 'Something went wrong. Please try again.',
        },
      });
      resetNotification('removal');
    }
  }, [jobService?.removing, jobService?.removalSuccess, jobService?.removalError]);

  const onPaginate = (inView): void => {
    if (jobService?.isLastPage || jobService?.fetching || !inView) return;
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.scrolled_through_jobs,
      properties: {
        pageNumber: jobService?.page + 1,
      },
    });
    dispatch({
      type: ActionTypes.job.getAllJobs.START,
      id: 'me',
      page: jobService?.page + 1,
    });
  };

  const deletePost = (id) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.deleted_job_post_jobs,
      properties: {
        jobId: id,
      },
    });
    dispatch({
      type: ActionTypes.job.removeJob.START,
      id,
    });
    setModalOpen(false);
    // setFilteredContent((prevStatement) => prevStatement.filter((item) => item.id !== questionId));
  };

  const renderEmpty = () => (
    <EmptyWrapper>
      <IconWrapper>
        <Icon name="post-fill" small color={Colors.GrayLight} />
      </IconWrapper>
      <TextWrapper>
        <Heading medium color={Colors.Gray}>No jobs</Heading>
      </TextWrapper>
      {!(jobService?.results ?? []).length
      && (
        <Body medium>
          <Link variant="text" onClick={() => history.push('/jobs/create-post', { from: 'Jobs' })} large>Add new</Link>
        </Body>
      )}
    </EmptyWrapper>
  );

  // FOR ARCHIVE FEATURE

  const clickLink = (id, fn) => {
    if (id !== jobId) {
      setJobId(id);
    }
    setModalFunction(fn);
    setModalOpen(true);
  };

  const archiveJob = (id) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.archived_job_post,
      properties: {
        jobId: id,
      },
    });
    dispatch({
      type: ActionTypes.jobItem.archive.START,
      body: [{
        op: 'replace',
        path: 'archived',
        value: true,
      }],
      id,
    });
    // setFilteredContent((prevContent) => prevContent.filter((item) => item?.id !== id));
    setModalOpen(false);
  };

  const unarchiveJob = (id) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.unararchived_job_post,
    });
    dispatch({
      type: ActionTypes.jobItem.archive.START,
      body: [{
        op: 'remove',
        path: 'archived',
        value: false,
      }],
      id,
    });
    // setFilteredContent((prevContent) => prevContent.filter((item) => item?.id !== id));
    setModalOpen(false);
  };

  const getModalText = () => {
    switch (modalFunction) {
    case 'delete':
      return 'Are you sure you want to delete job post?';
    case 'unarchive':
      return 'Are you sure you want to unarchive job post?';
    default:
      return 'Are you sure you want to archive job post?';
    }
  };

  const getChildrenText = () => {
    switch (modalFunction) {
    case 'delete':
      return 'Delete';
    case 'unarchive':
      return 'Unarchive';
    default:
      return 'Archive';
    }
  };

  const getModalFunction = () => {
    switch (modalFunction) {
    case 'delete':
      return () => deletePost(jobId);
    case 'unarchive':
      return () => unarchiveJob(jobId);
    default:
      return () => archiveJob(jobId);
    }
  };

  const _renderJobCards = () => jobService?.results?.map((item, index): React$Node => {
    if (!item) return null;
    const editJobPath = '/jobs/create-post/';
    const jobUrl = editJobPath.concat(item?._id);
    const locations = () => {
      const length = item?.locations?.length;
      if (!length && !item?.remote) return undefined;
      if (length > 1 || (item?.remote && length === 1)) return 'Multiple locations';
      if (item?.remote) return 'Remote';
      if (length === 1) return item?.locations[0]?.name;
    };
    // eslint-disable-next-line prefer-template
    const postDate = 'Posted ' + formatDate(item?.createdAt);

    return (
      <StyledCard
        key={index}
        variant="squircle"
        squircle={{
          iconName: 'post-fill',
          color: Colors.White,
          backgroundColor: Colors.GrayVeryDark,
          inverted: false,
        }}
        rightAction={{
          popover: {
            position: 'bottomLeft',
            links: [
              {
                children: 'Edit job post',
                large: true,
                onClick: () => history.push(jobUrl, { from: 'Jobs' }),
              },
              {
                children: item?.archived ? 'Unarchive job post' : 'Archive job post',
                large: true,
                color: Colors.SecondaryRed,
                onClick:
              item?.archived
                ? (() => clickLink(item?._id, 'unarchive'))
                : (() => clickLink(item?._id, 'archive')),
              },
              {
                children: 'Delete job post',
                large: true,
                color: Colors.SecondaryRed,
                onClick: () => clickLink(item?._id, 'delete'),
              },
            ],
          },
        }}
        title={item?.title}
        subtitle={locations()}
        body={postDate}
        archived={item?.archived}
        viewport={viewport}
      />
    );
  });

  // const onFilterButtonClick = (filterName: string) => {
  //   setActiveFilter(filterName);
  // };

  // const filterButtons = [
  //   {
  //     label: {
  //       text: `All jobs (${filterQty?.jobPosts || 0})`,
  //     },
  //     iconLeft: {
  //       name: 'post-fill',
  //     },
  //     onClick: () => onFilterButtonClick('jobPosts'),
  //     active: activeFilter === 'jobPosts',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  //   {
  //     label: {
  //       text: `Archived (${filterQty?.archived})`,
  //     },
  //     iconLeft: {
  //       name: 'archive-fill',
  //     },
  //     onClick: () => onFilterButtonClick('archived'),
  //     active: activeFilter === 'archived',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  // ];

  const leftSlot = (): React$Node => (
    <>
      <StyledHeadline
        variant="page"
        title={{ text: 'Jobs' }}
        squircleButton={isMobileSmall && {
          icon: { size: 'large' },
          onClick: () => history.push('/jobs/create-post', { from: 'Jobs' }),
        }}
        textLink={!isMobileSmall && {
          large: true,
          children: 'Add new',
          onClick: () => history.push('/jobs/create-post', { from: 'Jobs' }),
        }}
      />
      {/* {viewport !== 'desktop'
      && (
        <StyledButtonPillWrapper viewport={viewport} isMobile={isMobile}>
          {filterButtons.map((pill, index) => (
            <PillWrapper
              key={`pill-${index}-${pill?.label?.text}`}
              isMobile={isMobile}
              viewport={viewport}
              firstChild={index === 0}
              lastChild={index === (filterButtons?.length - 1)}
            >
              <Button variant="pill" {...pill} />
            </PillWrapper>
          ))}
        </StyledButtonPillWrapper>
      )} */}
    </>
  );

  const _renderLeftContent = () => {
    if (!(jobService?.results ?? []).length
    && (!jobService?.fetching
    && jobService?.success)
    ) {
      return <Card variant="list" renderEmpty={renderEmpty} />;
    }

    return (
      <>
        { _renderJobCards() }
        <InView as="div" onChange={onPaginate}>
          <SpinnerWrapper>
            {!jobService?.isLastPage && jobService?.fetching && <LoadingSpinner />}
          </SpinnerWrapper>
        </InView>
      </>
    );
  };

  const leftContent = (): React$Node => (
    <QuestionsWrapper isDesktop={viewport === 'desktop'}>
      {_renderLeftContent()}
      {jobService?.fetching && !(jobService?.results ?? []).length && (
        <SpinnerWrapper>
          <LoadingSpinner />
        </SpinnerWrapper>
      )}
    </QuestionsWrapper>
  );

  const rightSlot = (): React$Node => (
    <>
      {/* <Headline
        variant="default"
        title={{ text: 'Filter' }}
        style={{ marginBottom: '24px' }}
      />
      <ButtonPillGroup stacked pills={filterButtons} /> */}
    </>
  );

  return (
    <>
      <Helmet>
        <title>Jobs | ZIYNX</title>
      </Helmet>
      <DestructiveModal
        open={modalOpen}
        heading={{
          text: getModalText(),
        }}
        // body={{
        //   text: modalFunction === 'unarchive' ? 'This item will be displayed with all other content.' : 'The question will be displayed under "Archived".',
        // };
        buttonGroup={{
          destructive: {
            children: getChildrenText(),
            onClick: getModalFunction(),
          },
          primary: {
            children: 'Cancel',
            onClick: () => setModalOpen(false),
          },
        }}
      />
      <ContentContainer offsetTop={86}>
        <PageTemplate
          alwaysShowRightSlot
          viewport={viewport}
          leftSlot={leftSlot()}
          leftContent={leftContent()}
          rightSlot={rightSlot()}
          headerOffset={-1000} // Temporary measure to remove barSticky
        />
      </ContentContainer>
    </>
  );
};

export default (withAppManager(JobsScreen): React$ComponentType<ManagedProps<Props>>);
